<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="handleDialog" width="1000" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h5"><slot name="message"></slot></v-card-title>
                <v-card-text
                    class="common-dialog-message"
                >
                <v-container>
                    <v-row>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="必　須" color="red">
                                <label-component>氏名</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="alertName" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>メールアドレス</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-text-field required outlined disabled v-model="alertItem.email" background-color="white"></v-text-field>
                        </v-col>
                        <template v-if="alertItem.user.id == alertItem.id"> <!-- 本人のみ -->
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>パスワード更新</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <ValidationProvider name="パスワード" rules="min:8" v-slot="{ errors }">
                                    <v-text-field outlined clearable v-disabled-icon-focus v-model="password" type='password' hint="大文字、小文字、数字、記号を含む8文字以上でご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </template>
                        <template v-if="alertItem.plan == true && alertItem.user.role == true"> <!-- 有料プランかつ管理者 -->
                            <template v-if="alertItem.user.role == 1 && alertItem.user.id != alertItem.id"> <!-- 管理者かつ本人以外 -->
                                <v-col cols="12" xl="3">
                                    <badge-component tile color="unset">
                                        <label-component>管理者</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <v-switch
                                        v-model="alertRole"
                                        inset
                                        :label="alertRole? '権限を付与する' : '' "
                                    ></v-switch>
                                </v-col>
                            </template>
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>承認者</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <v-switch
                                    v-model="alertAuthorizer"
                                    inset
                                    :label="alertAuthorizer? '権限を付与する' : '' "
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>グループ</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <p class="text--primary">
                                    <template v-for="(org, index) in alertItem.organization_users">
                                       {{ org.organizations? org.organizations.name : '' }}　
                                    </template>
                                </p>
                            </v-col>
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>作業グループ</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <v-select
                                    v-model="workOrganizationId"
                                    placeholder="設定なし"
                                    :items="alertItem.organization_users"
                                    item-text="organizations.name"
                                    item-value="organizations.id"
                                    no-data-text="グループがありません"
                                    outlined
                                    clearable
                                    v-disabled-icon-focus
                                    background-color="white"
                                ></v-select>
                            </v-col>
                        </template>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk" :disabled="invalid">
                    <slot name="ok-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</ValidationObserver>
</template>

<script>
export default {
    data() {
        return {
            alertItem: this.item, // 子で親のインスタンスを更新するので、一度変数に移す（オブジェクトだが大丈夫か？）
            password: '',
        };
    },
    props: {
        item: {
            user: [],
            plan: Boolean,
            id: Number,
            name: String,
            email: String,
            role: String,
            is_authorizer: Number,
        },
        // ダイアログの開閉
        detailDialog: Boolean,
    },
    computed: {
        handleDialog: {
            get() {
                return this.detailDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:detailDialog', value);
            }
        },
        // オブジェクトの場合はプロパティをバインド（ v-model="alertItem.memo"等）してもリアクティブにならないのでgetter setterを定義してバインドが必要。
        alertName: {
            get() {
                return this.alertItem.name;
            },
            set(value) {
                this.alertItem.name = value;
            }
        },
        alertOrganizationId: {
            get() {
                return this.alertItem.organization_id;
            },
            set(value) {
                this.alertItem.organization_id = value;
            }
        },
        alertAuthorizer: {
            get() {
                return this.alertItem.is_authorizer;
            },
            set(value) {
                this.alertItem.is_authorizer = value;
            }
        },
        alertRole: {
            get() {
                return this.alertItem.role;
            },
            set(value) {
                this.alertItem.role = value;
            }
        },
        workOrganizationId: {
            get() {
                return this.alertItem.work_organization_id;
            },
            set(value) {
                this.alertItem.work_organization_id = value;
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            axios.post('/documents/update/' + this.alertItem.id, {
                name: this.alertName,
                password: this.password,
                is_authorizer: this.alertAuthorizer,
                role: this.alertRole,
                work_organization_id: this.workOrganizationId,
            }).then(res => {
                // 親コンポーネントへの通知
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
              // console.log(res);
                this.success = false;
                this.message = "処理に失敗しました";
                this.$emit("error", "処理に失敗しました");
            }).finally(() => {
            });
        },
    },
};
</script>